<template>
  <main class="ss-app__main" data-testid="ss-app-main-bare-layout">
    <slot name="main-content" />
  </main>
</template>
